$(function () {
  // put content in popup and show popup
  function getBenefit(benefits__item__icon, benefits__item__title, benefits__item__text) {
    $('.benefits__popup__inner__icon img').attr('src', benefits__item__icon);
    $('.benefits__popup__inner__body h2').text(benefits__item__title);
    $('.benefits__popup__inner__body div').html(benefits__item__text);
    $('html').addClass('popup-active');
  }

  // close benefit popup
  function closeBenefit() {
    $('html').removeClass('popup-active');
  }

  // get content of current benefit en call popup function
  $(document).on('click', '.benefits__item--popup', function() {
    var benefits__item__icon = $('img.benefits__item__icon', this).attr('src');
    var benefits__item__title = $('.benefits__item__title', this).text();
    var benefits__item__text = $('.benefits__item__text', this).html();

    getBenefit(benefits__item__icon, benefits__item__title, benefits__item__text);
  });

  // close benefit popup
  $(document).on('click', '.benefits__popup__toggle', function() {
    closeBenefit();
  });

  // close benefit popup when click outside popup
  $(document).on('mouseup', function(e){
    var container = $('.benefits__popup');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      closeBenefit();
    }
  });

  $(document).keydown(function(event) {
    if (event.keyCode == 27) {
      if( $('.popup-active').length != 0) {
        closeBenefit();
      }
    }
  });
});
